/*
 * @Descripttion: 供应商订单管理
 * @Date: 2024-12-02 17:12:49
 */
import { route } from './src/router';

const name = 'supplier-order';

export { name, route };
